import { Component, OnInit, HostListener } from '@angular/core';
import { HaLicenseServiceService } from '../../services/HaLicense.service';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';
import { ErrorModel } from '../../../../shared/models/Error.model';

@Component({
  selector: 'app-ha-new-license-management',
  templateUrl: './ha-new-license-management.component.html',
  styleUrls: ['./ha-new-license-management.component.css'],
})

export class HaNewLicenseManagementComponent implements OnInit {
  page: number = 1;
  showOverlayLicense: boolean;
  allLicenseList;
  licenseList;
  userList: any[];
  currentLicense: any;
  element: HTMLElement;
  elementMain: HTMLElement;
  tempLicenseList;
  filterLicenseVal: string = "ALL";
  listView: boolean = false;
  currentPage: number = 1;
  showLicenseLoad: boolean = false;
  filterLicense: number = 0;
  totalLicCount: number = 0;
  searchTerm: string = '';
  selectedLicenseType: number = 0;
  mainViewError = new ErrorModel();
  searchError = new ErrorModel();
  constructor(private _service: HaLicenseServiceService) {
  }

  ngOnInit() {
    this.totalLicCount = 0;
    this.filterLicense = 0;
    this.showLicenseLoad = false;
    this.currentPage = 1;
    this.showOverlayLicense = true;
    this.getLicenseList(this.currentPage, "", this.filterLicense);
  }

  getLicenseList(PageNo, searchText, licenseFilter) {
    this.mainViewError.display = false;
    this._service.getLicenseList(PageNo, searchText, licenseFilter).subscribe(
    (Data) => {
      this.showOverlayLicense = false;
      this.allLicenseList = Data["Data"];
      this.licenseList = Data["Data"];
      this.tempLicenseList = Data["Data"];
      if (this.licenseList != undefined && this.licenseList != null) {
        if (this.licenseList.length > 0) {
          this.userList = this.licenseList[0].users;
          this.currentLicense = this.licenseList[0];
        }
      }

      this.currentPage = 1;
      this.totalLicCount = Data["Count"];
    },
    (error) => {
      this.mainViewError.error = error;
      this.mainViewError.display = true;
    }).add(() => {
      this.showOverlayLicense = false;

    });
  }

  onScrollGetLicenses(searchText: string, filterType) {
    this.currentLicense = [];
    this.userList = [];
    this.showLicenseLoad = true;
    this.currentPage = this.currentPage + 1;
    this.filterLicense = filterType;
    this._service.getLicenseList(this.currentPage, searchText.trim(), this.filterLicense).subscribe(
    (data) => {
      let admins: any[] = data["Data"]
      if (admins != undefined) {
        admins.forEach(i => {
          this.licenseList.push(i)
        })
      }
      this.currentLicense = this.licenseList[0];
      this.userList = this.currentLicense.users;
      this.resetBorder();
      this.addBorder(0);
    },
    (error) => {
      AlertMessages.Show('Failed','Could not load!',AlertType.Error);

    }).add(() => {
      this.showLicenseLoad = false;
    });
  }

  searchUser(searchText: string, filterType) {
    this.currentLicense = [];
    this.userList = [];
    this.showLicenseLoad = true;
    this.searchError.display = false;
    this.currentPage = 1;
    this.filterLicense = filterType;
    this._service.getLicenseList(1, searchText.trim(), this.filterLicense).subscribe(
    (data) => {
      this.licenseList = data["Data"];
      if (this.licenseList !== undefined && this.licenseList !== null && this.licenseList.length > 0) {
        this.currentLicense = this.licenseList[0];
        this.userList = this.currentLicense.users;

        this.resetBorder();
        this.addBorder(0);
      }
    },
    (error) => {
      this.searchError.error = error;
      this.searchError.display = true;

    }).add(() => {
      this.showLicenseLoad = false;
    });
  }



  getUsersUnderLicense(id) {
    this.resetBorder();
    let index = this.licenseList.findIndex(license => license.id == id);
    this.addBorder(index);
    this.currentLicense = this.licenseList.filter(license => license.id == id)[0];
    this.userList = this.currentLicense["users"];
    if (this.licenseList[index].Used === false) {
    } else {
      this.openNav();
    }
  }

  resetBorder() {
    for (let license of this.licenseList) {
      license.border = "";
      license.borderBottom = "";
    }
  }

  addBorder(index) {
    this.licenseList[index].border = "2px solid #0969c9";
    this.licenseList[index].borderBottom = "2px solid #0969c9";
  }

  activeBlockLicense(data) {
    data.evt.stopPropagation();
    let isChecked: boolean = data.evt.target.checked;
    let index = this.licenseList.findIndex(license=> license.id == data.id);

    this._service.blockActiveLicense(data.id).subscribe(
    (message) => {

      this.licenseList[index].isLock = isChecked;
      let LicenseNo = this.licenseList[index].licenseNo;
      AlertMessages.Show(isChecked ? "Blocked" : "Success", LicenseNo + (isChecked ? " is Blocked" : "is Activated"),
        isChecked ? AlertType.Error : AlertType.Success);
    },
    (error) => {
      AlertMessages.Show('Failed','Could not perform!',AlertType.Error);
    });
  }

  stopProp(event) {
    event.stopPropagation();
  }

  openNav() {
    this.element = document.getElementById('slideDiv') as HTMLElement;
    this.element.style.marginRight = "0px";
    this.element.style.opacity = "1";
    this.elementMain = document.getElementById('main_content') as HTMLElement;
    this.elementMain.style.width = "70%";
  }

  closeNav() {
    this.element = document.getElementById('slideDiv') as HTMLElement;
    if (this.element !== undefined && this.element !== null) {
      this.element.style.marginRight = "-105%";
      this.element.style.opacity = "0";
    }
    this.elementMain = document.getElementById('main_content') as HTMLElement;
    if (this.elementMain !== undefined && this.elementMain !== null) {
      this.elementMain.style.width = "100%";
    }
    if (this.licenseList !== undefined && this.licenseList !== null && this.licenseList.length > 0) {
      for (let license of this.licenseList) {
        license.border = "";
        license.borderBottom = "";
      }
    }
  }


  copyToClip(data) {
    data.evt.stopPropagation();
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '-120%';
    selBox.style.top = '-50%';
    selBox.style.opacity = '0';
    selBox.value = data.licenseNo;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy', false, data.licenseNo);
    AlertMessages.Show("Copied", ' ' + data.licenseNo + ' Copied  ', AlertType.Add);
  }

}
